import { SystemFuncArgs } from '@brochington/ecstatic';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import CarnivoreSheetLayer from 'editor/components/CarnivoreSheetLayer';
import { getSheetToScreenTransform } from 'editor/utils/transform';
import { Components } from '../components';
import Canvas from '../components/Canvas';
import Space from '../components/Space';

export const renderSpaceComponents = [
  CarnivoreSheet,
  CarnivoreSheetLayer,
  Space,
  Canvas,
];

export function renderSpace(args: SystemFuncArgs<Components>): void {
  const { components, world } = args;
  const canvasComp = components.get(Canvas);
  const spaceComp = components.get(Space);
  const sheetComp = components.get(CarnivoreSheet);
  const sheetLayerComp = components.get(CarnivoreSheetLayer);
  const { sheet } = sheetComp;
  const { sheetLayer: spacesLayer } = sheetLayerComp;
  const { canvas } = canvasComp;
  const ctx = canvas.getContext('2d');

  if (!spaceComp.dirty) {
    return;
  }

  if (!ctx) {
    return;
  }

  if (!canvasComp.initialized) {
    canvas.width = sheet.width;
    canvas.height = sheet.height;

    canvasComp.initialized = true;

    ctx.transform(1, 0, 0, -1, 0, canvas.height);

    const transform = getSheetToScreenTransform(world);
    ctx.transform(...transform);

    ctx.fillStyle = '#FFFFFF';

    ctx.fillRect(0, 0, canvas.width, canvas.height);

    spacesLayer?.fillBuffer(canvas);
    spacesLayer.markAsDirty();
  }

  const [r, g, b] = spaceComp.space.color.components.toArray();

  ctx.fillStyle = `rgba(${r * 255}, ${g * 255}, ${b * 255}, ${
    spaceComp.space.opacity
  })`;

  ctx.beginPath();

  spaceComp.space.path.forEach((p, k) => {
    if (k === 0) {
      ctx?.moveTo(p.points[0], p.points[1]);
    } else {
      ctx?.lineTo(p.points[0], p.points[1]);
    }
  });

  ctx.fill();

  spaceComp.dirty = false;
}
